import { RigidBody } from '@react-three/rapier';
import { useRef, useState } from 'react';
import { useCursor } from '@react-three/drei';

export function Ball({ position, color, texture, scale }) {
    const sphereRef = useRef();
    const [hovered, setHovered] = useState(false);

    useCursor(hovered, 'pointer'); // Change cursor to pointer when hovered

    const force = scale === 0.4 ? 3 : 15;
    const other = scale === 0.4 ? 0.05 : 5;
    const spin = scale === 0.4 ? 0.05 : 2;

    const sphereJump = () => {
        if (sphereRef.current) {
            sphereRef.current.wakeUp();
            sphereRef.current.applyImpulse({ 
                x: other * Math.random() - 0.5, 
                y: force, 
                z: other * Math.random() - 0.5 
            });
            sphereRef.current.applyTorqueImpulse({
                x: spin * Math.random(),
                y: spin * Math.random(),
                z: spin * Math.random()
            });
        }
    };

    return (
        <RigidBody 
            ref={sphereRef} 
            colliders="ball" 
            onClick={sphereJump}
            onPointerOver={() => setHovered(true)}   // Detect hover start
            onPointerOut={() => setHovered(false)}   // Detect hover end
        >
            {/* Background Sphere */}
            <mesh position={position}>
                <sphereGeometry args={[scale, 28, 28]}/>
                <meshStandardMaterial color={color} roughness={0.6} />
            </mesh>

            {/* Sphere with Texture */}
            <mesh castShadow position={position}>
                <sphereGeometry args={[scale, 28, 28]} />
                <meshStandardMaterial map={texture} transparent={true} />
            </mesh>
        </RigidBody>
    );
}
